import { Component, Input } from '@angular/core';
import { Pathbar } from 'src/app/lem/models/common/pathbar';

@Component({
  selector: 'app-pathbar-lem',
  templateUrl: './pathbar-lem.component.html',
  styleUrls: ['./pathbar-lem.component.css']
})
export class PathbarLemComponent {

  @Input() pathbars: Pathbar[] = [];

  ngOnInit(){
    console.log(this.pathbars);
  }

}
